<h3 class="text--center mb-2">Why choose {{ client }}?</h3>
<ul>
  <dgx-cms-dynamic-component-outlet [area]="area">
  </dgx-cms-dynamic-component-outlet>
</ul>
